import _classCallCheck from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import _assertThisInitialized from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/assertThisInitialized";
import _inherits from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/inherits";
import _possibleConstructorReturn from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn";
import _getPrototypeOf from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/getPrototypeOf";
import _objectWithoutProperties from "/Users/spana/SHEIN/shineout/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/objectWithoutProperties";

function _createSuper2(Derived) {
  function isNativeReflectConstruct() {
    if (typeof Reflect === "undefined" || !Reflect.construct) return false;
    if (Reflect.construct.sham) return false;
    if (typeof Proxy === "function") return true;

    try {
      Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
      return true;
    } catch (e) {
      return false;
    }
  }

  return function () {
    var Super = _getPrototypeOf(Derived),
        result;

    if (isNativeReflectConstruct()) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

import React, { PureComponent } from 'react';
import immer from 'immer';
import classname from 'classnames';
import { uploadClass } from './styles';
import Upload from './Upload';
import { ERROR } from './request';
import { getLocale } from '../locale';
export var Handler = function Handler(_ref) {
  var className = _ref.className,
      disabled = _ref.disabled,
      urlInvalid = _ref.urlInvalid,
      children = _ref.children,
      style = _ref.style,
      width = _ref.width,
      height = _ref.height,
      onKeyDown = _ref.onKeyDown,
      onMouseDown = _ref.onMouseDown,
      otherProps = _objectWithoutProperties(_ref, ["className", "disabled", "urlInvalid", "children", "style", "width", "height", "onKeyDown", "onMouseDown"]);

  var mc = classname(uploadClass('image-plus', 'image-item', disabled && 'disabled', urlInvalid && 'url-invalid-border'), className);
  var ms = Object.assign({}, {
    width: width,
    height: height
  }, style);
  return (
    /*#__PURE__*/
    React.createElement("div", Object.assign({}, otherProps, {
      onKeyDown: onKeyDown,
      onMouseDown: onMouseDown,
      style: ms,
      tabIndex: disabled ? -1 : 0,
      className: mc
    }), children ||
    /*#__PURE__*/
    React.createElement("div", {
      className: uploadClass('indicator', urlInvalid && 'url-invalid-indicator')
    }))
  );
};
Handler.defaultProps = {
  width: 80,
  height: 80
};
var ImageUploadDefaultProps = {
  accept: 'image/*',
  height: 80,
  validator: {},
  width: 80
};

var Image =
/*#__PURE__*/
function (_PureComponent) {
  _inherits(Image, _PureComponent);

  var _super = _createSuper2(Image);

  function Image(props) {
    var _this;

    _classCallCheck(this, Image);

    _this = _super.call(this, props);
    _this.timeout = void 0;
    _this.beforeUpload = _this.beforeUpload.bind(_assertThisInitialized(_this));
    _this.handleMouseDown = _this.handleMouseDown.bind(_assertThisInitialized(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind(_assertThisInitialized(_this));
    _this.state = {
      urlInvalid: false
    };
    _this.timeout = null;
    return _this;
  }

  _createClass(Image, [{
    key: "beforeUpload",
    value: function beforeUpload(blob, validatorHandle) {
      var _this2 = this;

      return new Promise(function (resolve, reject) {
        var _ref2 = _this2.props.validator || {},
            imageSize = _ref2.imageSize;

        var file = {};
        var reader = new FileReader();

        reader.onload = function (e) {
          var data = e.target.result;
          file.data = data;
          var image = new window.Image();

          image.onerror = function () {
            _this2.setState(immer(function (draft) {
              draft.urlInvalid = true;
            }));

            reject();
          };

          image.onload = function () {
            if (!imageSize) {
              resolve(file);
              return;
            }

            var res = imageSize(image);

            if (res instanceof Error) {
              if (!validatorHandle(res, blob)) reject();
              file.status = ERROR;
              file.message = res.message;
            }

            resolve(file);
          };

          image.src = data;
        };

        reader.readAsDataURL(blob);
      });
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown(e) {
      this.setState({
        urlInvalid: false
      });
      if (e.keyCode === 13) e.target.click();
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown() {
      this.setState({
        urlInvalid: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          children = _this$props.children,
          width = _this$props.width,
          height = _this$props.height,
          ignorePreview = _this$props.ignorePreview,
          others = _objectWithoutProperties(_this$props, ["children", "width", "height", "ignorePreview"]);

      var urlInvalid = this.state.urlInvalid;

      if (urlInvalid) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(function () {
          _this3.setState({
            urlInvalid: false
          });
        }, 3000);
      }

      var style = {
        width: width,
        height: height
      };
      return (
        /*#__PURE__*/
        React.createElement(Upload, Object.assign({}, others, {
          imageStyle: style,
          beforeUpload: ignorePreview ? undefined : this.beforeUpload
        }),
        /*#__PURE__*/
        React.createElement(Handler, {
          disabled: this.props.disabled,
          style: style,
          onKeyDown: this.handleKeyDown,
          onMouseDown: this.handleMouseDown,
          urlInvalid: urlInvalid
        }, children), urlInvalid &&
        /*#__PURE__*/
        React.createElement("div", {
          style: {
            width: '100%',
            position: 'relative'
          }
        },
        /*#__PURE__*/
        React.createElement("div", {
          className: uploadClass('url-invalid-message')
        }, getLocale('urlInvalidMsg'))))
      );
    }
  }]);

  return Image;
}(PureComponent);

Image.defaultProps = ImageUploadDefaultProps;
export default Image;